import { render, staticRenderFns } from "./review-grid.vue?vue&type=template&id=288540a4&scoped=true&"
import script from "./review-grid.vue?vue&type=script&lang=js&"
export * from "./review-grid.vue?vue&type=script&lang=js&"
import style0 from "./review-grid.vue?vue&type=style&index=0&id=288540a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288540a4",
  null
  
)

export default component.exports